import deepmerge from "deepmerge";
import Head from "next/head";
import { useRouter } from "next/router";
import parseUrl from "parse-url";
import { useMemo } from "react";

import config from "@/lib/config";
import { defaultMetatags } from "@/lib/constants";

function mergeMetatags(defaultMetatags, metatags) {
  if (!metatags) return defaultMetatags;
  const tags = deepmerge(defaultMetatags, metatags);
  // ogキーとtwitterキーにのtitle, descriptionキーにmetatagsのtitleとdescriptionを代入している（metaタグとogpタグでtitle, descriptionを重複させてる）（これやらないとdefaultMetatagsの内容になってしまう）
  if (!metatags?.og?.title && metatags?.title) {
    tags.og.title = metatags.title;
  }
  if (!metatags?.og?.description && metatags?.description) {
    tags.og.description = metatags.description;
  }
  if (!metatags?.twitter?.title && metatags?.title) {
    tags.twitter.title = metatags.title;
  }
  if (!metatags?.twitter?.description && metatags?.description) {
    tags.twitter.description = metatags.description;
  }
  return tags;
}

export default function DefaultHeader({ metatags }) {
  const router = useRouter();
  const canonicalUrl = useMemo(() => {
    if (metatags?.canonicalUrl) {
      return metatags?.canonicalUrl;
    } else {
      const host = config.host["vod"];
      const parsed = parseUrl(`${host}${router.asPath}`);
      return `${host}${parsed.pathname}`;
    }
  }, [router, metatags]);

  const [path, themeColor, tags] = useMemo(() => {
    return ["/icon", "#feff00", mergeMetatags(defaultMetatags.vod, metatags)];
  }, [metatags]);

  return (
    <Head>
      <title key="title">{metatags?.title || tags.title}</title>
      <link rel="canonical" href={canonicalUrl} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, user-scalable=no"
      />
      <meta name="keywords" content={tags.keywords} key="keywords" />
      <meta name="description" content={tags.description} key="description" />
      <meta property="og:title" content={tags.og.title} key="ogtitle" />
      <meta property="og:type" content={tags.og.type} key="ogtype" />
      <meta property="og:url" content={tags.og.url} key="ogurl" />
      <meta property="og:image" content={tags.og.image} key="ogimage" />
      <meta
        property="og:site_name"
        content={tags.og.site_name}
        key="ogsite_name"
      />
      <meta
        property="og:description"
        content={tags.og.description}
        key="ogdescription"
      />
      <meta name="twitter:card" content={tags.twitter.card} key="twittercard" />
      <meta
        name="twitter:title"
        content={tags.twitter.title}
        key="twittertitle"
      />
      <meta
        name="twitter:description"
        content={tags.twitter.description}
        key="twitterdescription"
      />
      <meta
        name="twitter:image"
        content={tags.twitter.image}
        key="twitterimage"
      />
      <meta name="application-name" content={tags.appName} />

      <meta name="msapplication-TileColor" content={themeColor} />

      <meta name="theme-color" content={themeColor} />

      <meta name="apple-itunes-app" content="app-id=1666759583" />

      <link rel="shortcut icon" href={`${path}/favicon.ico`} />
      <link
        rel="apple-touch-icon-precomposed"
        href={`${path}/apple-touch-icon.png`}
      />
    </Head>
  );
}
